<template>
  <div>
    <Header v-bind="$attrs" />
    <slot />
    <Footer />
  </div>
</template>

<script>
import Header from 'components/layouts/default/Header.vue'
import Footer from 'components/layouts/application/Footer.vue'

export default {
  name: 'ApplicationLayoutDefault',

  components: {
    Header,
    Footer,
  },
}
</script>
